/* eslint-disable */

import axios from "axios";
import moment from "moment";
import momentTz from "moment-timezone";
const url = require("../../client_config/config").url;

const state = {
  item: [],
  clientInventoryLogItems: [],
  inventoryLogItems: [],
  dialog: false,
  pdfItem: ""
};

const getters = {
  getClientInventoryLogs: (state) => state.clientInventoryLogItems,
  getInventoryLogItems: (state) =>
    state.inventoryLogItems.map((item) => ({
      ...item,
      createdAt: moment(item.createdAt).format("YYYY-MM-DD"),
      signature: item?.mar?.Signature.split("-")[0].trim() || "",
      verifiedBy: item?.mar?.VerifiedBy.split("-")[0].trim() || "",
    })),
  getPDFDocument: (state) => state.pdfItem
};

const actions = {
  async getClientLogs({ commit }, id) {
    console.log(id);
    try {
      const response = await axios.get(
        `${url}/medicationInventory/client/logs/${id}`
      );
      commit("SET_CLIENT_INVENTORY_LOGS", response.data.data);
      return response.data.data;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async getInventoryLogs({ commit }, data) {
   let tz = momentTz.tz.guess();
    try {
      const response = await axios.get(`${url}/medicationInventory/logs/${data.id}`, {
        params: {
          download: data.download,
          tz
        }
      });
      if(data.download){
        let pdfFile = "data:application/octet-stream;base64," + response.data.data;
        commit("SET_DOWNLOAD_REPORT", pdfFile);
        return
      }
      commit("SET_INVENTORY_LOGS", response.data.data);
      return response.data.data;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },


  async updateMedicationInventory({ commit }, data) {
    try {
      const response = await axios.put(
        `${url}/medicationInventory/item/${data.id}`,
        {
          Quantity: data.Quantity,
        }
      );
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },
};

const mutations = {
  SET_CLIENT_INVENTORY_LOGS(state, data) {
    state.clientInventoryLogItems = data;
  },

  SET_INVENTORY_LOGS(state, data) {
    state.inventoryLogItems = data;
  },

  SET_DIALOG(state, data){
    state.dialog = data;
  },

  SET_DOWNLOAD_REPORT(state, data){
    state.pdfItem = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
